import CanOutputSection from './CanOutputSection'

export default CanOutputSection;
